import { Component, Input } from '@angular/core';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import { NotificationOfEmergencyOccupationFormValue } from '../../forms/notification-of-emergency-occupation.form';
import { DatePipe } from '@angular/common';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';

@Component({
  selector: 'app-notification-of-emergency-occupation-preview',
  standalone: true,
  imports: [LabelComponent, DatePipe, ParcelsPreviewComponent],
  templateUrl: './notification-of-emergency-occupation-preview.component.html'
})
export class NotificationOfEmergencyOccupationPreviewComponent {

  @Input()
  occupation: NotificationOfEmergencyOccupationFormValue | undefined;
}
